import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { controlToastState } from "risa-oasis-ui_v2";
import { downloadFilesFromSftp } from "../../../../api/postCall/downloadFilesFromSftp";
import { PushToSftpTableDataModel } from "../../../../data-model/pushToSftpDataModel";
import { PushToSftpModalTableColumnKeys } from "../../../../enums/tableColumnKeys";
import { closeModal } from "../../../../redux/slice/modalSliceNew";
import { AppDispatch } from "../../../../redux/store/store";

export const onDownloadInternalFiles = async (
  tableData: PushToSftpTableDataModel[],
  dispatch: AppDispatch,
  setTableData: (data: PushToSftpTableDataModel[]) => void,
): Promise<void> => {
  const selectedData = tableData.filter(
    (item) => item[PushToSftpModalTableColumnKeys.SELECT]?.isChecked,
  );

  if (selectedData.length === 0) {
    controlToastState("download-files-no-selection");
    return;
  }

  const selectedFilenames = selectedData
    .map((item) => item[PushToSftpModalTableColumnKeys.FILENAME])
    .filter((filename): filename is string => filename !== undefined);

  if (selectedFilenames.length === 0) {
    controlToastState("download-files-no-selection");
    return;
  }

  try {
    // Use /uploads directory for internal files download
    const remoteDir =
      process.env.REACT_APP_ENV === "production"
        ? "/uploads"
        : "/risa_internal";
    await downloadFilesFromSftp(selectedFilenames, remoteDir);

    // Close the modal and reset table data
    setTableData([]);
    dispatch(closeModal());
  } catch (error) {
    console.error("Error downloading files from SFTP:", error);
    toast.error("Error downloading file from SFTP");
  }
};
